import { bff, createBFFHandlers } from '~/framework/bff';
import { z } from 'zod';
import { getServerSideMonolithClient } from '~/framework';
import { searchUsers as searchUsersFromMonolith, SearchUsersOptions } from '~/monolith-api';

const searchUsersSchema = z.object({
   searchTerm: z.string(),
   limit: z.number().optional(),
   page: z.number().optional(),
   uniqueOnly: z.boolean().optional(),
});

export async function searchUsers(searchTerm: string, options: SearchUsersOptions | undefined) {
   return await searchUsersFromMonolith(searchTerm, options);
}

export default createBFFHandlers({
   post: async (req, res) => {
      const { searchTerm, limit, page, uniqueOnly } = searchUsersSchema.parse(req.body);
      const monolithClient = getServerSideMonolithClient(req);
      const result = await searchUsersFromMonolith(searchTerm, {
         limit,
         page,
         uniqueOnly,
         apiClient: monolithClient,
      });
      res.status(200).json(result);
   },
});

export const searchUsersFromClient = (
   searchTerm: string,
   options?: SearchUsersOptions
): ReturnType<typeof searchUsers> => {
   return bff()
      .post('/users/searchUsers', {
         searchTerm,
         ...options,
      })
      .then(response => response.data);
};
